export default "__VITE_ASSET__CKMW18YA__"